import {
  UPDATE_AUTH_USER,
  UPDATE_USER_EMAIL,
  UPDATE_USER_PRODUCTS,
  UPDATE_USER_ROLE,
} from './constants'

export const setAuthUser = (user) => (dispatch) => {
  dispatch({
    type: UPDATE_AUTH_USER,
    payload: user,
  })
}

export const setUserEmail = (userEmail) => (dispatch) => {
  dispatch({
    type: UPDATE_USER_EMAIL,
    payload: userEmail,
  })
}
export const setUserProducts = (productList) => (dispatch) => {
  dispatch({
    type: UPDATE_USER_PRODUCTS,
    payload: productList,
  })
}

export const setUserRole = (userRole) => (dispatch) => {
  dispatch({
    type: UPDATE_USER_ROLE,
    payload: userRole,
  })
}

export const refreshUserEmail = () => (dispatch) => {
  const userEmail = localStorage.getItem('email')
  dispatch({
    type: UPDATE_USER_EMAIL,
    payload: userEmail,
  })
}
